import i18n from '../../../../shared/locales/no.json';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

class OnboardingUserProfile extends Component {
    static propTypes = {
        user: PropTypes.shape({
            displayName: PropTypes.string.isRequired,
            email: PropTypes.string.isRequired,
            profilePictureUrl: PropTypes.string.isRequired,
        }),
    };

    render() {
        const user = this.props.user || {};
        const imgUrl = user.profilePictureUrl;

        return (
            <div className="panel">
                <p>{i18n['You are logged in as']}</p>
                <div className="u-r-size1of7">
                    <div className="r-mrm r-mln">
                        <img
                            className="image-frame profile-image-xsmall"
                            src={imgUrl}
                        />
                    </div>
                </div>
                <div className="u-r-size6of7">
                    <p className="largetext man">{user.displayName}</p>
                    <p className="man licorice">{user.email}</p>
                </div>
            </div>
        );
    }
}

export default OnboardingUserProfile;
